export default __webpack_public_path__ + "static/media/Ape-X.27a99a93.png";